// Card component for static content
// In this version we don't use a spiner, because means to be SSR
// If exist, the Spinner will not be shown
/*
WARNING!!!

page is loading dinamically script code
for that reason we are using dangerously-set-html-content
but this is a dangeours technique

The normal would be use dangerouslySetInnerHTML and not load external script

<div dangerouslySetInnerHTML={{ __html: text }} />

However, that would make some pages stopped to works, like "refer a friend"
*/
import InnerHTML from 'dangerously-set-html-content';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { DEFAULT_LOCATION } from '../../config/setup/setup';
import { trackPage } from '../../helpers/analytics';
import { getLocationShortName } from '../../helpers/location';

export default function StaticCard({ text }) {
  const router = useRouter();
  const [location] = useSelector((state) => [state.locations.location]);
  const pageProps = {
    location: getLocationShortName(location),
    siteLocation:
      location && location.name
        ? location.name
        : DEFAULT_LOCATION[process.env.NEXT_PUBLIC_SITE || 'wowcher'].name,
  };
  const pageName =
    router && router.query
      ? router.query.slug[0].toString().replace(/.html/gi, '')
      : '';
  useEffect(() => {
    trackPage(pageProps, pageName);
  }, []);

  return (
    <div className="static static__background">
      <InnerHTML html={text} />
    </div>
  );
}
